import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import DataTable from "../Reusable/DataTable";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import Button from "../Reusable/Button";
import { useState } from "react";
import Modal from "../Reusable/Modal";
import SyncContact from "./SyncContact";
import { useNavigate } from "react-router-dom";
import usePermission from "../../customHooks/usePermission";

const RiderList = (props: any) => {
  const { handleIsActive, handleIsEnableSMS, handleIsEnableEmail } = props;
  const { isSuperUser } = usePermission();
  const navigate = useNavigate();
  const canEditRider = usePermission({
    allowedPermissions: ["can_update_rider"],
  });
  const handleRowClick = (row: any) => {
    if (!canEditRider) return;
    navigate(`edit/${row.original.id}`);
  };

  const [openSyncContactPopUp, setOpenSyncContactPopup] = useState(false);
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "user.full_name",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "user.mobile_number",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "user.email",
      cell: NACell,
    },
    {
      header: "License Number",
      accessorKey: "license_number",
      cell: NACell,
    },

    {
      header: "Citizenship",
      accessorKey: "citizen_ship_number",
      cell: NACell,
    },
    {
      header: "Branch",
      accessorKey: "branch.name",
      cell: NACell,
    },
    {
      header: "SMS",
      accessorKey: "is_enable_sms",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableSMS}
          />
        </div>
      ),
    },
    {
      header: "Email",
      accessorKey: "is_enable_email",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsEnableEmail}
          />
        </div>
      ),
    },
    {
      header: "Active",
      accessorKey: "user.is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.user?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_rider"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },

    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`/edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_rider"]}
    //       />
    //     </>
    //   ),
    // },
  ];

  return (
    <>
      <DataTable
        url={APIS.DRIVER}
        queryKey={"driver"}
        columns={defaultColumns}
        addNewPagePath={"create"}
        tableName={"rider-driver"}
        actionMenu={
          <>
            <div className={tw`flex items-center justify-end w-full `}>
              <div className={tw`w-24`}>
                <Button
                  label={"Sync Contact"}
                  type="button"
                  onClick={() => setOpenSyncContactPopup(true)}
                />
              </div>
            </div>
          </>
        }
        onRowClick={handleRowClick}
      />
      <Modal
        title={"Sync Contact"}
        isOpen={openSyncContactPopUp}
        setIsOpen={setOpenSyncContactPopup}
      >
        <SyncContact setOpenSyncContactPopup={setOpenSyncContactPopup} />
      </Modal>
    </>
  );
};

export default RiderList;
